import {
  REASONING_EFFORTS,
  ReasoningEffort,
} from './axios/api/chat';

export const REASONING_EFFORT_STORAGE_KEY = 'chat.reasoningEffort';
export const DEFAULT_REASONING_EFFORT: ReasoningEffort = 'medium';

export function getStoredReasoningEffort(): ReasoningEffort {
  const value = localStorage.getItem(REASONING_EFFORT_STORAGE_KEY);

  if (REASONING_EFFORTS.includes(value as ReasoningEffort)) {
    return value as ReasoningEffort;
  }

  return DEFAULT_REASONING_EFFORT;
}

export function setStoredReasoningEffort(value: ReasoningEffort) {
  localStorage.setItem(REASONING_EFFORT_STORAGE_KEY, value);
}
